// Framework
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { use } from "react";

// MUI
import { Box, CircularProgress, Stack } from "@mui/material";

// Components
import ParticipationDetailsPage from "@components/modules/participations/ParticipationDetailsPage";
import { ElementNotFound } from "@components/errors/ElementNotFound";
import IconButton from "@/components/IconButton";

// Hooks
import { useGetParticipationQuery } from "@/api/ParticipationsApi";
import { ParticipationContext } from "@contexts/ParticipationContext";

export const Route = createFileRoute(
  "/_dashboard/modules/$uuid/participations/$participationUuid"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { participationUuid, uuid } = Route.useParams();
  const { data: participation, isLoading } =
    useGetParticipationQuery(participationUuid);
  const session = Route.useRouteContext();
  const isAdmin = session.session?.user!.isAdmin;

  const handleGoBack = () => {
    navigate({
      to: "/modules/$uuid/$tab",
      params: {
        uuid,
        tab: "participations",
      },
    });
  };

  if (isLoading)
    return (
      <Stack justifyContent={"center"} alignItems={"center"}>
        <CircularProgress />
      </Stack>
    );

  if (!participation) return <ElementNotFound />;

  return (
    <ParticipationContext.Provider value={participation}>
      <Stack gap={2}>
        <IconButton
          onClick={handleGoBack}
          icon={"tabler:chevron-left"}
          sx={{ alignSelf: "flex-start" }}
        />
        <ParticipationDetailsPage
          isAdmin={!!isAdmin}
          participation={participation}
        />
      </Stack>
    </ParticipationContext.Provider>
  );
}
